import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component scrolls the window and any scrollable main containers
 * to the top (0, 0) whenever the route path or query parameters change.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // 1. Reset main window scroll
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });

    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // 2. Reset admin main scroll container
    const adminMain = document.getElementById('admin-main-content');
    if (adminMain) {
      adminMain.scrollTop = 0;
    }

    // 3. Reset any active overflow scroll containers
    const scrollContainers = document.querySelectorAll('main, .overflow-y-auto, .overflow-auto');
    scrollContainers.forEach((container) => {
      container.scrollTop = 0;
    });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
